var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-item',{attrs:{"card":"item_subscription","tabs":_vm.tabs,"id":("" + _vm.id)},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}})}
var staticRenderFns = []

export { render, staticRenderFns }